module.exports = __webpack_public_path__ + "static/media/4.71f9bddb.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/4.png
// module id = 1139
// module chunks = 0